<div class="full-width" [class.offers]="type === NoteType.OFFER_MEMBER" *ngIf="refId">
  <div class="notes-header" *ngIf="hideControls">
    <div class="notes-header__title">
      <ng-content select="[notes-title]"></ng-content>
    </div>
    <div class="control-buttons flex-right">
      <ng-content select="[notes-controls]"></ng-content>
    </div>
  </div>

  <div class="control-buttons flex-right" *ngIf="!hideControls">
    <button
      mat-stroked-button
      class="mat-primary stroked"
      (click)="onCreate()"
      *ngIf="!createMode && changedNoteIndex == -1"
      [disabled]="disableEdit"
    >
      {{ 'button.addNote' | loc }}
    </button>
    <ng-container *ngIf="createMode || changedNoteIndex != -1">
      <button mat-stroked-button class="mat-primary stroked" (click)="onCancel()" [disabled]="disableEdit">
        {{ 'button.cancel' | loc }}
      </button>
      <button
        mat-flat-button
        class="mat-primary flat"
        (click)="onSave()"
        [disabled]="
          disableEdit || noteDescriptionControl.invalid || !noteDescriptionValue || (!contentOnly && noteTitleControl.invalid)
        "
      >
        {{ 'button.saveNote' | loc }}
      </button>
    </ng-container>
  </div>
  <ng-container *ngIf="createMode">
    <ng-container *ngTemplateOutlet="noteTemplate; context: { data: null, editMode: true, index: -1 }"></ng-container>
  </ng-container>
  <ng-container *ngFor="let note of notes; let i = index">
    <ng-container *ngTemplateOutlet="noteTemplate; context: { data: note, editMode: changedNoteIndex == i, index: i }">
    </ng-container>
  </ng-container>
  <p class="notes-empty" *ngIf="!createMode && notes.length === 0 && emptyTextKey">{{ emptyTextKey | loc }}</p>
</div>

<ng-template #noteTemplate let-data="data" let-editMode="editMode" let-index="index">
  <mat-expansion-panel
    class="fliko-panel mat-elevation-z0"
    [class.fliko-panel--content-only]="contentOnly"
    [expanded]="contentOnly || index <= 0"
  >
    <mat-expansion-panel-header *ngIf="!contentOnly" [class.edit]="editMode">
      <mat-panel-title>
        <!-- ! stop immediate propagation is to omit expansion panel closing / opening on text input click and space -->
        <app-text-input
          *ngIf="editMode"
          [formControl]="noteTitleControl"
          placeholder="placeholder.noteTitle"
          (click)="$event.stopImmediatePropagation()"
          (keydown.Space)="$event.stopImmediatePropagation()"
          [disabled]="disableEdit"
          max="100"
        ></app-text-input>
        <div *ngIf="!editMode" class="title">
          <span class="date">{{ data.lastUpdate | lDate: 'dShort' }}</span> {{ data.title }}
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div>
      <div class="font-14" *ngIf="!editMode">{{ data.description }}</div>
      <div class="note-control" *ngIf="!editMode">
        <div class="user-name">
          <span *ngIf="contentOnly">{{ data.lastUpdate | lDate: 'dtShort' }} · </span>
          {{ 'label.createdBy' | loc }}: {{ getUserData(data) }}
        </div>
        <div class="margin-right-5 flex-right" *ngIf="data.userId == undefined || currentUserId == data.userId">
          <app-icon-button
            icon="edit"
            (click)="onEdit(data, index)"
            [matTooltip]="'button.edit' | loc"
            [disabled]="disableEdit"
          ></app-icon-button>
          <app-icon-button
            icon="delete"
            (click)="onDelete(data)"
            [matTooltip]="'button.delete' | loc"
            [disabled]="disableEdit"
          ></app-icon-button>
        </div>
      </div>
    </div>
    <app-text-input
      *ngIf="editMode"
      [formControl]="noteDescriptionControl"
      type="textarea"
      placeholderKey="placeholder.noteContent"
      max="800"
    ></app-text-input>
  </mat-expansion-panel>
</ng-template>
